import React, { useEffect, useState } from 'react'
import s from './AccordionManager.module.css'
import { Accordion } from '@components/ui'

export interface AccordionProps {
  items?: any
  small?: boolean
  showIndices?: boolean
  titleProp?: string
  contentProp?: string
  autoSelectFirst?: boolean
}

const AccordionManager: React.FC<AccordionProps> = ((props) => {

  const {
    items,
    small,
    showIndices,
    titleProp,
    contentProp,
    autoSelectFirst
  } = props

  const [showIndex, setShowIndex] = useState(autoSelectFirst === false ? 0 : 1)

  const manageIndex = (index: number) => {
    if (index === showIndex) {
      setShowIndex(0)
    } else {
      setShowIndex(index)
    }

  }

  return (
    items?.map((item: any, index: number) => (
      <Accordion key={item._key ?? `accordion-item-${index}`} index={(index + 1).toString()} manageIndex={manageIndex} showIndex={showIndex} showIndices={showIndices}
                 small={small} title={titleProp != null ? item[titleProp] : item.title} content={contentProp != null ? item[contentProp] : item.content} />
    ))
  )
})

export default AccordionManager
